import cn from 'classnames';

import type { FC } from 'react';

import './StageColorSquare.scss';

interface StageColorSquareProps {
  color?: string | null;
}

export const StageColorSquare: FC<StageColorSquareProps> = ({ color }) => (
  <span
    className={cn('StageColorSquare', { 'StageColorSquare--empty': !color })}
    style={color ? { backgroundColor: color } : undefined}
    aria-hidden="true"
  />
);
